var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { TranslateService } from "@ngx-translate/core";
import { MenuContainerBaseComponent } from "./../../../../common-theme/base-components/shared/menu/menu-container-base/menu-container-base.component";
import { AfterViewInit, ElementRef, } from "@angular/core";
import { AgencyService } from "../../../../common-theme/api/agency.service";
// import { CookieHeightChangeService } from '../../../../common-theme/utils/cookie/cookie-height-change.service';
import { LocaleService } from "../../../../common-theme/index";
var MenuContainerComponent = /** @class */ (function (_super) {
    __extends(MenuContainerComponent, _super);
    function MenuContainerComponent(agencyService, localeService, document, translate // private cookieHeightChangeService: CookieHeightChangeService
    ) {
        var _this = _super.call(this, agencyService, document) || this;
        _this.agencyService = agencyService;
        _this.localeService = localeService;
        _this.document = document;
        _this.translate = translate; // private cookieHeightChangeService: CookieHeightChangeService
        _this.marginTop = 0;
        return _this;
    }
    MenuContainerComponent.prototype.ngAfterViewInit = function () {
        // this.cookieHeightChangeService.emitter.subscribe(height => this.menu.nativeElement.style.marginTop = height + 'px');
    };
    return MenuContainerComponent;
}(MenuContainerBaseComponent));
export { MenuContainerComponent };



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-container/menu-container.component.ts.pre-build-optimizer.js